import moment from 'moment';
import _ from 'lodash';
import { integrationsByCategory } from 'shared/core/constants/integrations';
import { flagIsEnabledForDispensary } from 'shared/utils/evaluate-dispensary-feature-flag';

export const formatBirthdayForRewards = (dateString) => {
  const date = moment(dateString, ['MM-DD-YYYY', 'YYYY-MM-DD', 'MM/DD/YYYY']);
  if (date.isValid()) {
    return date?.format('YYYY-MM-DD');
  }
  return '';
};

export const rewardsProgramEnabled = (cart, featureFlags = {}) => {
  const rewardAdapters = _.keys(integrationsByCategory.rewards);
  const { consumerDispensaryIntegrations, id: dispensaryId } = cart.order?.dispensary;
  // Fyllo is currently behind a flag.
  const fylloFlagEnabled = flagIsEnabledForDispensary('rollout.enable-fyllo-integration', featureFlags, dispensaryId);

  return !!_.find(rewardAdapters, (adapter) => {
    const integrationEnabled = consumerDispensaryIntegrations?.[adapter]?.enabled;
    return adapter === 'fyllo' ? fylloFlagEnabled && integrationEnabled : integrationEnabled;
  });
};
